import { useRef, useState } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { CheckIcon } from 'lucide-react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useSnapshot } from 'valtio';
import * as yup from 'yup';

import PortalHeading from '../../components/pages/customer-portal/heading.jsx';
import {
  turnstileStatusState,
  turnstileStatusStateStatuses,
  TurnstileWidget,
} from '../../components/turnstile-widget.jsx';
import { Button } from '../../components/ui/button.jsx';
import { Card } from '../../components/ui/card.jsx';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../../components/ui/form.jsx';
import { Input } from '../../components/ui/input.jsx';
import { msCatalystApi } from '../../services/api/ms-catalyst-api.js';

export const PasswordRecoverRequest = () => {
  const navigate = useNavigate();
  const [sentRecoverPasswordEmail, setSentRecoverPasswordEmail] =
    useState(false);
  const formRef = useRef();
  const turnstileRef = useRef();
  const { status: turnstileStatus, setStatus: setTurnstileStatus } =
    useSnapshot(turnstileStatusState);

  const formRecoverPasswordRequest = useForm({
    resolver: yupResolver(
      yup.object().shape({
        email: yup
          .string()
          .min(1, 'Por favor insira o seu email')
          .email('Email inválido')
          .required(),
      }),
    ),
    defaultValues: {
      email: '',
    },
  });

  // TODO: refactor to mutation
  async function onSubmit(data) {
    try {
      const formData = new FormData(formRef.current);
      const turnstileToken = formData.get('cf-turnstile-response');

      if (!turnstileToken) {
        toast.error(
          'Erro ao pedir código único de alteração de palavra-passe',
          {
            description:
              'Não foi possível determinar com sucesso a sua veracidade como humano',
          },
        );

        return;
      }

      await msCatalystApi.post('/auth/reset-password', {
        email: data.email,
        turnstile_token: turnstileToken,
      });

      setSentRecoverPasswordEmail(true);

      setTimeout(() => {
        navigate('/auth/login');
      }, 4000);
    } catch (err) {
      toast.error('Erro ao enviar email de alteraçãp de palavra-passe');

      setTurnstileStatus('pending');
      turnstileRef.current?.reset();
    }
  }

  return (
    <Card className="p-4 sm:p-10">
      {sentRecoverPasswordEmail ? (
        <div className="flex flex-col items-center">
          <CheckIcon className="size-40 text-success" />
          <PortalHeading className="text-center !text-2xl">
            Email para recuperar palavra-passe enviado com sucesso!
          </PortalHeading>

          <div className="py-4 text-center">
            <p className="mb-2">
              Pode agora começar o processo de recuperação da palavra-passe a
              partir do link que vai receber no seu e-mail.
            </p>
            <p>
              Por favor aguarde enquanto o redirecionamos para a página de
              login...
            </p>
          </div>
        </div>
      ) : (
        <>
          <div className="flex flex-col space-y-2 pb-4 text-left">
            <PortalHeading className="!text-xl">
              Não se lembra da sua palavra-passe?
            </PortalHeading>
            <p className="text-sm text-muted-foreground">
              Introduza o e-mail associado à sua conta.
            </p>
          </div>
          <div className="grid gap-6">
            <Form {...formRecoverPasswordRequest}>
              <form
                ref={formRef}
                onSubmit={formRecoverPasswordRequest.handleSubmit(onSubmit)}
              >
                <div className="grid gap-2">
                  <FormField
                    control={formRecoverPasswordRequest.control}
                    name="email"
                    render={({ field }) => (
                      <FormItem variant="portal">
                        <FormLabel>E-mail</FormLabel>
                        <FormControl>
                          <Input type="email" {...field} />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </div>

                <div className="pt-4">
                  <TurnstileWidget ref={turnstileRef} />
                </div>

                <div className="flex flex-col items-center pt-8">
                  <Button
                    variant="portal"
                    className="w-full"
                    disabled={
                      !formRecoverPasswordRequest.formState.isDirty ||
                      formRecoverPasswordRequest.formState.isSubmitting ||
                      turnstileStatus !== turnstileStatusStateStatuses.SOLVED
                    }
                    isLoading={
                      formRecoverPasswordRequest.formState.isSubmitting
                    }
                  >
                    Recuperar palavra-passe
                  </Button>

                  <div className="flex flex-col pt-5">
                    <Button
                      asChild
                      variant="link"
                      type="button"
                      className="h-auto text-xs font-medium text-muted-foreground hover:opacity-75"
                    >
                      <Link to="/auth/register">
                        Não possui uma conta? Registe-se aqui
                      </Link>
                    </Button>

                    <Button
                      asChild
                      variant="link"
                      type="button"
                      className="h-auto text-xs font-medium text-muted-foreground hover:opacity-75"
                    >
                      <Link to="/auth/login">
                        Já possui uma conta? Entre aqui
                      </Link>
                    </Button>
                  </div>
                </div>
              </form>
            </Form>
          </div>
        </>
      )}
    </Card>
  );
};
